import React, { useContext, Suspense } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AppContext } from '../contexts/AppContext'
import { AppLoading } from '../pages'
import FallbackPage from './FallbackPage'
import { useRouter } from '../hooks'

const AuthenticatedRoute = ({
  component: Component,
  subscriptionRequired,
  adminRequired,
  ...rest
}: any) => {
  const { location, match } = useRouter()
  const { state } = useContext(AppContext)

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!state.ready) {
          return <AppLoading {...props} />
        }

        if (
          state.isAuthenticated &&
          !state.user?.teamBrands?.length &&
          location.pathname !== '/a/program/new/'
        ) {
          return <Redirect to="/a/program/new/" />
        }

        if (rest.path && match.path === rest.path) {
          if (
            state.isAuthenticated &&
            subscriptionRequired &&
            !state.teamBrand?.subscriptions?.length
          ) {
            return <Redirect to="/a/program/subscription/" />
          }

          if (state.isAuthenticated && adminRequired && !state.user?.isAdmin) {
            return <Redirect to="/a/dashboard/" />
          }
        }

        return state.isAuthenticated === true ? (
          <Suspense fallback={<FallbackPage />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect to="/login/" />
        )
      }}
    />
  )
}

export default AuthenticatedRoute
